import classNames from "classnames";
import { FC } from "react";
import Price from "./price";
import { THEME, THEME_LIVE } from "../config";
import { convertOdds } from "../convertOdds";

export type AHSpecialProps = {
  outcomeId?: string;
  isLoading?: boolean;
  isLive?: boolean;
  label?: string;
  price?: string | number;
  oddsType?: number;
  marketId?: string;
  matchId?: string;
  leagueId?: string;
  option: number;
  sp?: string;
  onClick?: (data: {
    option: number;
    leagueId: string;
    outcomeId: string;
    sp: string;
    marketId: string;
    matchId: string;
  }) => void;
  spd?: boolean;
};

const AHSpecial: FC<AHSpecialProps> = ({
  isLoading = false,
  isLive = false,
  outcomeId = "",
  label = "",
  price = 0,
  oddsType = 0,
  marketId = "",
  matchId = "",
  sp = "",
  leagueId = "",
  option,
  onClick,
  spd = false
}) => {
  const theme = isLive ? THEME_LIVE : THEME;
  const finalPrice = convertOdds(Number(price), oddsType);
  return (
    <div
      key={outcomeId}
      className={`flex-1 ${theme.secordaryB} border border-white`}
      style={{ minWidth: 62 }}>
      <div className="text-blue-700 font-semibold text-xs p-1">
        {isLoading ? (
          <div className="rounded bg-gray-200 h-2 animate-pulse w-1/2 mx-auto" />
        ) : (
          label
        )}
      </div>
      <div
        className={classNames("font-semibold py-1", {
          "text-red-600": Number(finalPrice) < 0,
        })}>
        {isLoading ? (
          <div className="rounded bg-gray-200 h-2 animate-pulse w-1/2 mx-auto" />
        ) : (
          <button
            className={classNames("cursor-pointer", {
              "text-gray-500 cursor-not-allowed": spd,
            })}
            onClick={() => {
              onClick?.({
                outcomeId: outcomeId,
                sp: sp,
                marketId: marketId,
                matchId: matchId,
                leagueId,
                option,
              });
            }}
            disabled={spd}
          >
            { spd ? '-' : <Price value={finalPrice} sp={`${outcomeId}|${sp}|${matchId}`} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default AHSpecial;
